import Hero from "@/components/jf/Hero";
import Marquee from "@/components/jf/Marquee";
import Shop from "@/components/jf/Shop";
import Manifesto from "@/components/jf/Manifesto";
import Journey from "@/components/jf/Journey";
import Founder from "@/components/jf/Founder";
import Craft from "@/components/jf/Craft";
import Collections from "@/components/jf/Collections";
import Clientele from "@/components/jf/Clientele";
import Ambaari from "@/components/jf/Ambaari";
import Contact from "@/components/jf/Contact";

export default function HomePage({ onBook, selectedProduct }) {
  return (
    <main>
      <Hero />
      <Marquee />
      <Shop onBook={onBook} />
      <Manifesto />
      <Journey />
      <Founder />
      <Craft />
      <Collections />
      <Clientele />
      <Ambaari />
      <Contact selectedProduct={selectedProduct} />
    </main>
  );
}
